import { routes } from '@routes';
import { Log, User, UserManager, UserManagerSettings } from 'oidc-client';
import { joinBaseUri } from '../common/pages'; // do not change to '@common'

class AuthService {
  public userManager: UserManager;

  constructor() {
    const settings = {
      authority: SummeetConfig.authority,
      client_id: SummeetConfig.clientId,
      redirect_uri: joinBaseUri(SummeetConfig.clientRoot, routes.ssoCallback.path),
      automaticSilentRenew: true,
      silent_redirect_uri: joinBaseUri(SummeetConfig.clientRoot, routes.silentRenew.path),
      // tslint:disable-next-line:object-literal-sort-keys
      post_logout_redirect_uri: joinBaseUri(SummeetConfig.clientRoot, '/'),
      response_type: SummeetConfig.responseType,
      scope: SummeetConfig.clientScope,
      loadUserInfo: false,
    } as UserManagerSettings;
    this.userManager = new UserManager(settings);

    Log.logger = console;
    Log.level = Log.INFO;
  }

  public async getUser(): Promise<User | null> {
    let user = await this.userManager.getUser();
    if (user && user.expired) {
      try {
        user = await this.userManager.signinSilent();
      } catch(ex) {
        console && console.error(ex);
        user = null;
      }
    }
    return user;
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }

  public async getAccessToken(): Promise<string> {
    const user = await this.getUser();
    return user && user.access_token;
  }
}

export const authService = new AuthService();
